var numbers = '\\d+(?:[\\.,]\\d+)?';
var timePattern = new RegExp("T(".concat(numbers, "H)?(").concat(numbers, "M)?(").concat(numbers, "S)?"));
// Converts values from ISO 8601 durations, such as "PT11M26.143791666S", to seconds (in this case 686.143791666)
// Currently only works with minutes, hours and seconds, as higher than that relies on context a lot more
// (eg: length of a month), but we primarily seem to see this using only those values anyway
// (eg: "PT928H43M15.355S", rather than dividing the 928 hours into days)
export var ptTimeToSeconds = function(ptTime) {
    var _ptTime_match;
    var timeValues = ((_ptTime_match = ptTime.match(timePattern)) === null || _ptTime_match === void 0 ? void 0 : _ptTime_match.slice(1)) || [];
    return timeValues.reverse().reduce(function(acc, numStr, idx) {
        return numStr ? parseFloat(numStr) * Math.pow(60, idx) + (acc !== null && acc !== void 0 ? acc : 0) : acc;
    }, null);
};

//# sourceMappingURL=pt-time-conversion.js.map